// extracted by mini-css-extract-plugin
export var hidden = "_sp-0";